import React from "react"
import { Loading } from "."

const Loadable = ({ isLoaded, children }) => {
  return isLoaded ? children : <Loading />
}

export default Loadable
